export default __webpack_public_path__ + "assets/images/70910b3a23e3ac1576cc71c09d07b0b4.svg";